import React, { FC, ReactElement } from 'react';

import { RatingTypes } from '@buyside/components/presentation/IdeaShowPage/Rating/ratingArea';
import Star from '@buyside/components/presentation/IdeaShowPage/Rating/Star/star';
import { defaultStopColor, userStopColor, starNumbers } from './constants';

import { noop } from '@buyside/util/lodashAlt';

import { Maybe } from '@interfaces/graphql-typings';

const calculateFill = (num: number, rating: Maybe<number>): number => {
  if (!rating) return 0;

  if (rating >= num) {
    return 100;
  } else if (rating > num - 1) {
    return (rating - (num - 1)) * 100;
  }
  return 0;
};

const RatingStars: FC<{
  disabled?: boolean;
  handleClick?: (num: number) => void;
  handleHover?: (num: number) => void;
  handleReset?: () => void;
  hideRating?: boolean;
  rating: Maybe<number>;
  selectedStar?: number;
  submitting?: boolean;
  type: string;
}> = ({
  type,
  rating,
  hideRating,
  disabled,
  submitting,
  selectedStar = 0,
  handleHover = noop,
  handleReset = noop,
  handleClick = noop
}): ReactElement => (
  <>
    {type === RatingTypes.COMMUNITY || rating || disabled ? (
      <>
        {starNumbers.map(
          (num): ReactElement => (
            <Star
              key={num}
              num={num}
              type={type}
              // why divide by 2: rating is on the scale of 1 to 10 and expressed by 5 stars
              // - TMA (31 Mar 2020)
              fillPercentage={hideRating ? 0 : calculateFill(num, (rating || 0) / 2)}
              stopColor={type === RatingTypes.CURRENT_USER ? userStopColor : defaultStopColor}
            />
          )
        )}
      </>
    ) : (
      <>
        {starNumbers.map(
          (num): ReactElement => (
            <Star
              key={num}
              num={num}
              type={type}
              dataHeap="your-rating"
              Tag={submitting ? 'span' : 'a'}
              stopColor={userStopColor}
              fillPercentage={selectedStar < num ? 0 : 100}
              onMouseEnter={submitting ? noop : (): void => handleHover(num)}
              onMouseLeave={handleReset}
              onClick={submitting ? noop : (): void => handleClick(num)}
            />
          )
        )}
      </>
    )}
  </>
);
export default RatingStars;
